import React, { useRef, useState, useCallback } from "react";

const BEFORE =
  "https://customer-assets.emergentagent.com/job_polish-medford/artifacts/19n15s63_bf%2044.jpg";
const AFTER =
  "https://customer-assets.emergentagent.com/job_polish-medford/artifacts/7h6urne2_bf%2022.jpg";

const GALLERY = [
  {
    url: "https://images.unsplash.com/photo-1732357624591-f2137085659b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxjYXIlMjBpbnRlcmlvciUyMGNsZWFuaW5nfGVufDB8fHx8MTc3OTc2MzYzN3ww&ixlib=rb-4.1.0&q=85",
    title: "Deep Interior Reset",
    tag: "Interior",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_polish-medford/artifacts/cixa4lte_the-best-car-wash-soap-for-a-cleaner-car.webp",
    title: "Full Exterior Polish",
    tag: "Exterior",
  },
];

export default function BeforeAfter() {
  const [pos, setPos] = useState(50);
  const containerRef = useRef(null);
  const dragging = useRef(false);

  const updatePos = useCallback((clientX) => {
    if (!containerRef.current) return;
    const rect = containerRef.current.getBoundingClientRect();
    const x = clientX - rect.left;
    const pct = Math.max(0, Math.min(100, (x / rect.width) * 100));
    setPos(pct);
  }, []);

  const onDown = (e) => { dragging.current = true; updatePos(e.clientX); };
  const onMove = (e) => { if (dragging.current) updatePos(e.clientX); };
  const onUp = () => { dragging.current = false; };

  return (
    <section id="gallery" data-testid="gallery-section" className="py-24 md:py-32 bg-white">
      <div className="container mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-12 gap-8 mb-16 items-end">
          <div className="md:col-span-7">
            <div className="text-[11px] tracking-[0.3em] uppercase font-bold text-blue-600 mb-4">
              Before / After
            </div>
            <h2 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-[0.95]">
              The transformation<br />speaks for itself.
            </h2>
          </div>
          <div className="md:col-span-5">
            <p className="text-slate-600 leading-relaxed">
              Drag the slider to see real results from real Southern Oregon
              vehicles. Hand corrected paint, restored trim, like new interiors.
            </p>
          </div>
        </div>

        <div
          ref={containerRef}
          className="ba-container h-[420px] md:h-[560px] cursor-ew-resize select-none border border-slate-200"
          onMouseDown={onDown}
          onMouseMove={onMove}
          onMouseUp={onUp}
          onMouseLeave={onUp}
          onTouchStart={(e) => onDown(e.touches[0])}
          onTouchMove={(e) => onMove(e.touches[0])}
          onTouchEnd={onUp}
          data-testid="before-after-slider"
        >
          <img src={BEFORE} alt="Before detailing" className="absolute inset-0 w-full h-full object-cover" draggable={false} />
          <div className="ba-after" style={{ width: `${pos}%` }} data-testid="ba-after-layer">
            <img
              src={AFTER}
              alt="After detailing"
              className="w-full h-full object-cover"
              style={{
                width: containerRef.current ? `${containerRef.current.offsetWidth}px` : "100%",
                maxWidth: "none",
              }}
              draggable={false}
            />
          </div>
          <div className="absolute top-4 left-4 bg-slate-900 text-white text-[10px] tracking-[0.3em] uppercase font-bold px-3 py-1.5">Before</div>
          <div className="absolute top-4 right-4 bg-blue-600 text-white text-[10px] tracking-[0.3em] uppercase font-bold px-3 py-1.5">After</div>
          <div className="ba-handle" style={{ left: `calc(${pos}% - 1.5px)` }}>
            <div className="ba-knob">⇄</div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-slate-200 mt-px border-x border-b border-slate-200">
          {GALLERY.map((g, i) => (
            <div key={i} data-testid={`gallery-item-${i}`} className="relative bg-white overflow-hidden group">
              <img src={g.url} alt={g.title} className="w-full h-64 object-cover transition-transform duration-700 group-hover:scale-105" />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 via-slate-900/0 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <div className="text-[10px] tracking-[0.3em] uppercase font-bold text-blue-300 mb-1">{g.tag}</div>
                <div className="font-display font-black text-xl text-white tracking-tight">{g.title}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
